__turbopack_context__.v({
  "AnchorDisabled": "Button-module-scss-module__EtFxQG__AnchorDisabled",
  "Button": "Button-module-scss-module__EtFxQG__Button",
  "ButtonDark": "Button-module-scss-module__EtFxQG__ButtonDark",
  "ButtonIcon": "Button-module-scss-module__EtFxQG__ButtonIcon",
  "ButtonLight": "Button-module-scss-module__EtFxQG__ButtonLight",
  "ButtonNone": "Button-module-scss-module__EtFxQG__ButtonNone",
  "ButtonPreIcon": "Button-module-scss-module__EtFxQG__ButtonPreIcon",
  "ButtonText": "Button-module-scss-module__EtFxQG__ButtonText",
  "ButtonTextual": "Button-module-scss-module__EtFxQG__ButtonTextual",
  "ButtonTextualWhite": "Button-module-scss-module__EtFxQG__ButtonTextualWhite",
});
